import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.object.values.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { BILLING_TYPE } from 'src/boot/constants';
export default {
  name: 'BillingIcon',
  props: {
    billed: {
      type: Number,
      required: true,
      validator: function validator(value) {
        return [0, 1, 2].includes(value);
      }
    },
    projectBillingType: {
      type: String,
      required: true,
      validator: function validator(value) {
        return Object.values(BILLING_TYPE).includes(value);
      }
    },
    size: {
      type: Number,
      default: 17
    }
  },
  computed: {
    entryIsBilled: function entryIsBilled() {
      return this.billed === 1 && this.projectBillingType === BILLING_TYPE.TIME_MATERIAL;
    },
    entryIsUnbilled: function entryIsUnbilled() {
      return this.billed === 0 && this.projectBillingType === BILLING_TYPE.TIME_MATERIAL;
    },
    entryIsNotBillable: function entryIsNotBillable() {
      return this.billed === 2 && this.projectBillingType === BILLING_TYPE.TIME_MATERIAL;
    },
    projectIsBillablePerHour: function projectIsBillablePerHour() {
      return this.projectBillingType === BILLING_TYPE.TIME_MATERIAL;
    },
    billedTooltip: function billedTooltip() {
      if (this.entryIsNotBillable) {
        return this.$t('general.not_billable');
      } else if (this.entryIsUnbilled) {
        return this.$t('general.unbilled');
      } else if (this.entryIsBilled) {
        return this.$t('general.billed');
      }

      return '';
    }
  }
};